function urlToLog(url) {
    return new URL(url.pathname, url.origin);
}

export { urlToLog };
//# sourceMappingURL=url.js.map
